var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25532",
    "data-name": "Grupo 25532",
    transform: "translate(-1744 -126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25481",
    "data-name": "Grupo 25481",
    transform: "translate(1744 126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2133",
    "data-name": "Elipse 2133",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69311",
    "data-name": "Trazado 69311",
    d: "M1213.889,478.045l-3.4-3.4a6.776,6.776,0,0,0-4.819-2h-4.391a4.87,4.87,0,0,0-4.868,4.868v13.63a4.869,4.869,0,0,0,4.868,4.868h9.735a4.87,4.87,0,0,0,4.868-4.868v-8.285A6.775,6.775,0,0,0,1213.889,478.045Zm-1.373,1.373a4.935,4.935,0,0,1,.788,1.022h-4.225a.976.976,0,0,1-.973-.974v-4.225a4.951,4.951,0,0,1,1.022.789l3.4,3.4Zm1.421,11.731a2.929,2.929,0,0,1-2.921,2.921h-9.735a2.929,2.929,0,0,1-2.921-2.921v-13.63a2.929,2.929,0,0,1,2.921-2.921h4.391a3.936,3.936,0,0,1,.477.019v4.848a2.929,2.929,0,0,0,2.921,2.921h4.849a3.87,3.87,0,0,1,.019.477Zm-12.568-5.841h-1.061a.977.977,0,0,0-.974.974V490.6a.6.6,0,0,0,.6.6.607.607,0,0,0,.6-.6v-1.188h.818a2.054,2.054,0,1,0,0-4.108Zm0,2.891h-.808v-1.674h.818a.838.838,0,1,1,0,1.674Zm11.614-2.278a.6.6,0,0,1-.6.6h-1.645v1.11h1.207a.6.6,0,0,1,.6.6.607.607,0,0,1-.6.6h-1.207v1.752a.6.6,0,0,1-1.207,0v-4.683a.6.6,0,0,1,.6-.6h2.249a.6.6,0,0,1,.6.6Zm-6.746-.6h-1.061a.977.977,0,0,0-.974.974v4.323a.554.554,0,0,0,.6.545h1.421a2.073,2.073,0,0,0,2.083-2.054v-1.733a2.074,2.074,0,0,0-2.083-2.054Zm.866,3.787a.863.863,0,0,1-.866.837h-.808v-3.408h.818a.863.863,0,0,1,.867.837V489.1Z",
    transform: "translate(562.351 -334.334)",
    fill: "#f8fbfd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPdf);
export default __webpack_public_path__ + "static/media/Icono-PDF.1fc6592ce94e1c44066c480c13f2a95c.svg";
export { ForwardRef as ReactComponent };